module.exports = __webpack_public_path__ + "img/noispick.07e72b98.png";